import { memo } from "react";

// UI
import VehicleLocationFields from "ui/modules/fleet/vehicles/pages/components/VehicleLocationFields/VehicleLocationFields";

// Servisni sloj
import { VEHICLE_LOCATION_TYPE_CONFIG } from "services/api/fleet/vehicles/locations/consts";

import { VehicleTransferFormProps } from "./types";

/**
 * Korak premještaja — odabir nove lokacije vozila. Raspored prati korak "Lokacija"
 * iz unosa vozila, jer je riječ o istom unosu.
 */
const VehicleTransferForm: React.FC<VehicleTransferFormProps> = (props) => {
  const { values, errors, onChange, currentLocation } = props;

  // Odakle se vozilo premješta — bez toga se ne vidi što se točno mijenja.
  const currentLocationLabel = currentLocation?.locationType
    ? [
        VEHICLE_LOCATION_TYPE_CONFIG[currentLocation.locationType]?.label,
        currentLocation.name,
      ]
        .filter(Boolean)
        .join(": ")
    : null;

  return (
    <div className="flex items-start justify-center px-4 pt-12 pb-6">
      <div className="w-full max-w-4xl">
        <h1 className="text-2xl font-bold text-slate-900 text-center mb-1mb-2">
          Premještaj vozila
        </h1>
        <p className="text-center text-md text-slate-500 mb-8">
          Odaberite gdje želite premjestiti vozilo
        </p>

        <div className="border bg-white border-slate-200">
          <div className="py-6 px-4">
            {/* Bez naslova odjeljka — korak ima samo jedan, a naslov iznad već kaže o čemu
                je riječ. Ostaje trenutna lokacija: pokazuje odakle se vozilo miče. */}
            {currentLocationLabel && (
              <p className="text-xs text-slate-500 mb-3">
                Trenutno: {currentLocationLabel}
              </p>
            )}
            {/* Datum i napomena su na drugom koraku — ovdje se odgovara samo na "gdje". */}
            <VehicleLocationFields
              values={values}
              errors={errors}
              onChange={onChange}
              layout="grid"
              showValidFrom={false}
              showNote={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(VehicleTransferForm);
